var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotagIconPurpleContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1A222D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6658 26C19.7198 26.001 18.7825 25.8172 17.9059 25.4587C18.3234 25.2479 18.71 24.9799 19.0547 24.6625C19.3977 24.3469 19.6954 23.9847 19.9393 23.5865C20.4449 22.7627 20.6968 21.8064 20.6632 20.8385C20.6316 19.9138 20.3456 19.0161 19.837 18.2456C19.3284 17.4752 18.6173 16.8623 17.783 16.4755L17.7815 16.4742L17.7808 16.4722L17.7813 16.4703L17.7827 16.4688C18.3604 16.1148 18.8402 15.6199 19.1778 15.0297C19.4947 14.4738 19.6752 13.8495 19.704 13.209C19.7328 12.5686 19.6092 11.9304 19.3435 11.3478C20.2704 11.1782 21.2209 11.1884 22.144 11.3778C23.0821 11.5713 23.9733 11.949 24.7666 12.4892C25.9457 13.2907 26.8687 14.4196 27.4238 15.739C27.6113 16.1858 27.7544 16.6502 27.851 17.1254C28.0497 18.1077 28.0497 19.1203 27.851 20.1025C27.6588 21.0474 27.2838 21.9448 26.7474 22.7436C25.9512 23.9312 24.8303 24.8608 23.5205 25.4196C23.0769 25.6085 22.6158 25.7527 22.144 25.85C21.6575 25.9499 21.1623 26.0001 20.6658 26ZM15.6328 26H9.004L9.0025 25.9997L9.0012 25.9989L9.00033 25.9977L9 25.9962V15.7606C8.99989 15.3033 9.04558 14.8471 9.13636 14.399C9.31217 13.5347 9.65524 12.7137 10.146 11.983C10.8743 10.8966 11.8997 10.0464 13.0979 9.53516C13.5036 9.36239 13.9254 9.23051 14.3569 9.14142C14.8021 9.05002 15.2552 9.00404 15.7095 9.00417V9C16.4745 9.00057 17.2234 9.22203 17.8674 9.63814C18.5114 10.0543 19.0238 10.6475 19.3435 11.3478C18.0878 11.579 16.9136 12.1373 15.9383 12.9671C15.2985 13.5107 14.7552 14.1601 14.3319 14.8875C13.8025 15.8022 13.4744 16.8209 13.3697 17.8746C13.265 18.9282 13.3862 19.9922 13.7251 20.9945C14.064 21.9969 14.6126 22.9142 15.3339 23.6843C16.0552 24.4545 16.9324 25.0597 17.9059 25.4587C17.2005 25.8152 16.422 26.0006 15.6328 26Z",
    fill: "url(#paint0_linear_13768_47744)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13768_47744",
    x1: 29.5285,
    y1: 3.05,
    x2: 9.40469,
    y2: 36.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotagIconPurpleContainer);
export default __webpack_public_path__ + "static/media/botag-icon-purple-container.ba866d8463fe9bd25537646a05e5585f.svg";
export { ForwardRef as ReactComponent };